import React, { forwardRef, useEffect } from 'react';
import { InputListItem } from '../input-list-item/input-list-item';
export var InputBool = forwardRef(function (_a, ref) {
    var name = _a.name, legend = _a.legend, setValue = _a.setValue, value = _a.value, onChange = _a.onChange, disabled = _a.disabled;
    useEffect(function () {
        if (value) {
            setValue(name, value);
        }
    }, [value]);
    return (React.createElement("fieldset", null,
        React.createElement("legend", null, legend),
        React.createElement("div", { className: "l-flex l-flex--wrap" },
            React.createElement("div", null,
                React.createElement(InputListItem, { type: "radio", id: "yes-".concat(name), name: name, value: "true", displayText: "Yes", ref: ref, onChange: onChange, disabled: disabled })),
            React.createElement("div", null,
                React.createElement(InputListItem, { type: "radio", id: "no-".concat(name), name: name, value: "false", displayText: "No", ref: ref, onChange: onChange, disabled: disabled })))));
});
InputBool.displayName = 'InputBool';
